import { ConsoleLogAdapter } from 'library/ts/utilities/logger/adapters/ConsoleLogAdapter';
import { LogService } from 'library/ts/utilities/logger/LogService';
import { LOGGER_ADAPTERS, LogMethods } from 'library/ts/utilities/logger/LogServiceConstants';
export class Logger {
    options;
    availableAdapters = {
        [LOGGER_ADAPTERS.CONSOLE]: ConsoleLogAdapter
    };
    constructor(options = {}) {
        this.options = Object.assign({}, this.defaultOptions, options);
    }
    get utils() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    get defaultOptions() {
        return {
            prefixes: [],
            adapters: [LOGGER_ADAPTERS.CONSOLE],
            noTimestamp: false
        };
    }
    #adapters;
    get adapters() {
        if (this.utils.Type.isEmpty(this.#adapters)) {
            this.#adapters = {};
            this.options.adapters.forEach((adapterKey) => {
                this.#adapters[adapterKey] = this.availableAdapters[adapterKey].create();
            });
        }
        return this.#adapters;
    }
    get prefixTimestamp() {
        const msFromStart = LogService.timeElapsed;
        const secFromStart = msFromStart / 1000;
        return '(T+' + secFromStart + 'sec)';
    }
    #callAdapters = (method, ...messages) => {
        if (!LogService.methodIsAvailable(method))
            return;
        Object.keys(this.adapters).forEach((adapterKey) => {
            const adapter = this.adapters[adapterKey];
            if (!this.utils.Type.isNullOrUndefined(adapter?.[method]) && this.utils.Type.isFunction(adapter?.[method]) && messages) {
                const toLog = [
                    ...(!this.options?.noTimestamp ? [this.prefixTimestamp] : []),
                    ...(this.options.prefixes || []),
                    ...(messages || [])
                ];
                adapter[method](...toLog);
            }
        });
    };
    log(...messages) {
        return this.#callAdapters(LogMethods.LOG, ...messages);
    }
    info(...messages) {
        return this.#callAdapters(LogMethods.INFO, ...messages);
    }
    warn(...messages) {
        return this.#callAdapters(LogMethods.WARN, ...messages);
    }
    error(...messages) {
        return this.#callAdapters(LogMethods.ERROR, ...messages);
    }
    table(...messages) {
        return this.#callAdapters(LogMethods.TABLE, ...messages);
    }
    group(...messages) {
        return this.#callAdapters(LogMethods.GROUP, ...messages);
    }
    groupCollapsed(...messages) {
        return this.#callAdapters(LogMethods.GROUP_COLLAPSED, ...messages);
    }
    groupEnd(...messages) {
        return this.#callAdapters(LogMethods.GROUP_END, ...messages);
    }
}
